module.exports = __webpack_public_path__ + "img/art_4_4.8fd42db9.png";